/**
 * Presentation mapping for a listing's `sale_status`.
 *
 * Kept free of React/intl so it can be unit-tested and shared. Both the
 * marketplace cards and the profile drawer's Partial Sale Listings render
 * status from here — they previously hand-rolled it, and the drawer's copy
 * had drifted onto statuses that do not exist ('active' / 'pending'), so every
 * badge there fell through to the neutral default.
 *
 * The values mirror PartialSaleListing's enum:
 *   new = 0 (Draft), open = 1 (Published), closed = 2 (Closed)
 */

const I18N_PREFIX = 'succession.partial_sales.marketplace';

const NEUTRAL = 'bg-succession-bg-secondary text-succession-text-secondary border border-succession-border';

const BY_STATUS = {
  new: {
    labelId: `${I18N_PREFIX}.status_draft`,
    className: NEUTRAL,
  },
  open: {
    labelId: `${I18N_PREFIX}.status_published`,
    className: 'bg-succession-success-bg text-succession-success border border-succession-success',
  },
  closed: {
    labelId: `${I18N_PREFIX}.status_closed`,
    className: 'bg-succession-error-bg text-succession-error border border-succession-error',
  },
};

const UNKNOWN = {
  labelId: `${I18N_PREFIX}.status_unknown`,
  className: NEUTRAL,
};

/**
 * @param {string|null|undefined} saleStatus - the listing's sale_status
 * @returns {{ labelId: string, className: string }} i18n key + badge classes
 */
export const partialSaleStatusDisplay = (saleStatus) => BY_STATUS[saleStatus] || UNKNOWN;

export default partialSaleStatusDisplay;
